import React from 'react'

import { ChartEventBadgeType } from '../../../constants/common'
import { IChartEventBadgeProps } from '../utils'
import { chartBadgeSvgByType } from './chart-badges-svg-by-type'

export const getChartEventBadgeElement = (props: IChartEventBadgeProps & { badgeType: ChartEventBadgeType }) => {
  const svgHtmlString = chartBadgeSvgByType[props.badgeType](props)

  return <span dangerouslySetInnerHTML={{ __html: svgHtmlString }}></span>
}
